import React, { createContext, ReactNode, useContext, useMemo } from "react";

export interface WalletQueryScope {
  businessId?: string | null;
}

const WalletScopeContext = createContext<WalletQueryScope>({});

interface WalletScopeProviderProps {
  businessId?: string | null;
  children: ReactNode;
}

export const WalletScopeProvider: React.FC<WalletScopeProviderProps> = ({
  businessId,
  children,
}) => {
  const value = useMemo<WalletQueryScope>(
    () => (businessId ? { businessId } : {}),
    [businessId]
  );

  return (
    <WalletScopeContext.Provider value={value}>
      {children}
    </WalletScopeContext.Provider>
  );
};

export const useWalletScope = (): WalletQueryScope => {
  return useContext(WalletScopeContext);
};
